<div class="stepper-body">
    <div class="body-title">
        <span>Your loan app is created!</span>
    </div>
    <div class="body-description">
        <span>Click continue to complete your application and upload documents.</span>
    </div>

    <div class="icon">
        <i class="fa-regular fa-ballot-check"></i>
    </div>
</div>
<div class="stepper-footer">
    <mat-divider></mat-divider>
    <div class="step-controls">
        <button [style.visibility]="isDialog ? 'visible' : 'hidden'" mat-stroked-button color="primary" (click)="onClose()" class="step-button secondary" [disabled]="false">
            Close
        </button>
        <button mat-flat-button color="primary" (click)="onContinue()" class="step-button primary"
            [disabled]="false">
            Continue
        </button>
    </div>
</div>